import React, { useEffect, useState, useRef } from 'react'
import './forms.css'
import './background.css'
import { useDispatch, useSelector } from 'react-redux';
import { getProfile, saveProfile } from '../../../redux/reducers/profileSlice';
import BackgroundContainer from './BackgroundContainer';
import CropperCom from './CropperCom';
import inputErrors from '../../helpers/validation'
import Loader from '../../helpers/Loader';
import { ChromePicker } from 'react-color';
import { NamefontFamilies } from "./font"
// import { snackbarContext } from '../../helpers/Snakbar';
import BannerPreview from './Previews/Banner/BannerPreview';


const BASIC_DETAILS_FIELDS = [
    "groomName",
    "brideName",
    "hashtag"
];


const BasicDetailsForm = ({ onNext }) => {
    //    const setStateSnackbarContext = React.useContext(snackbarContext);
    const formRef = useRef(null);
    const { weddingData: profileData, loading } = useSelector((state) => state.profile)
    // const { user } = useSelector((state) => state.auth)
    const [values, setValues] = useState({
        brideName: "Bride Name",
        groomName: "Groom Name",
        hashtag: "",
        // bannerImage: {
        //     url: "bg.png",
        //     public_id: ""
        // },
        fontAlignment: "bottom",
        fontColor: "#f5f5f5",
        nameFontStyle: "Playfair Display', serif",
        displayOrder: "",
        bannerType:"",
        bannerImage:{
            url:"",
            public_id:""
        }
    })
    const [isSubmitting, setSubmitting] = useState(false);
    const dispatch = useDispatch()
    const [defalutBgConatiner, setdefalutBgConatiner] = useState(false)
    const [errors, setErrors] = useState({})
    const [showCropper, setShowCropper] = useState(false)
    const [displayColorPicker, setDisplayColorPicker] = useState(false);
    
    const handleChange = (event) => {
        setValues({
            ...values,
            [event.target.name]: event.target.value
        });
    }

    const handleColorChange = (color) => {
        setValues({ ...values, fontColor: color.hex });
    };

    const handleSubmit = (e) => {
        e.preventDefault()
        const validationErrors = inputErrors(
        values,
        BASIC_DETAILS_FIELDS
    );
        setErrors(validationErrors)
        setSubmitting(true)
    }


    const savedata = () => {
        setSubmitting(false)
        dispatch(saveProfile({values, onNext }))
    }

    useEffect(() => {
        dispatch(getProfile())
        window.scrollTo(0, 0);
    }, [])

    useEffect(() => {
        setValues({ ...profileData })
    }, [profileData])




    useEffect(() => {
        if (isSubmitting) {
            const noErrors = Object.keys(errors).length === 0;
            if (noErrors) {
                savedata()
            } else {
                formRef.current.scrollIntoView({ behavior: "smooth" });
            }

        }
    }, [isSubmitting, errors])


    const handleDefaultBg = () => setdefalutBgConatiner(prevValue => !prevValue)

    const rerenderBg = (bg) => {
        setValues({
            ...values,
            bannerImage: {
                url: bg,
                public_id: values.bannerImage.public_id
            }
        })
    }

    const handleCropper = () => setShowCropper(prevValue => !prevValue)

    const internalCss = `
    .wed-detail-date::before,
.wed-detail-date::after {
    background-color:${values.fontColor}
}
 .preview-custom-icon path {
    fill:${values.fontColor} ; 
  }
  
    `


    if (loading) {
        return <Loader />
    }
    const toggleColorPicker = () => {
        setDisplayColorPicker(!displayColorPicker);
    };

    const handleClose = () => {
        setDisplayColorPicker(false);
    };
    
    const groomFeild=()=>{
        return(
            <>
     <div className={errors.groomName ? "form-input-div-error" : "form-input-div"}>
                                    <input type="search"
                                        name="groomName"
                                        value={values.groomName}
                                        onChange={handleChange}
                                        placeholder=' '
                                        className={errors.groomName ? "form-input-field-error" : "form-input-field"}
                                    />
                                    <label>Groom First Name <span style={{ color: "red" }}> *</span></label>
                                </div>
                                <div className='error-wedding-div'>  {errors.groomName && (<small className="error-msg-wedding">{errors.groomName}</small>)}</div>
                                </>
        )
    }

    const brideFeild=()=>{
        return(
            <>
  <div className={errors.brideName ? "form-input-div-error" : "form-input-div"}>
                                    <input type="search"
                                        name="brideName"
                                        value={values.brideName}
                                        onChange={handleChange}
                                        placeholder=' '
                                        className={errors.brideName ? "form-input-field-error" : "form-input-field"}
                                    />
                                    <label>Bride First Name  <span style={{ color: "red" }}> *</span></label>
                                </div>
                                <div className='error-wedding-div'>  {errors.brideName && (<small className="error-msg-wedding">{errors.brideName}</small>)}</div>
            </>
        )
    }


    return (
        <>
            {/* <Progress activeStep={0} demoVersion={user && user.demoVersion} /> */}
            <style>{internalCss}</style>
            <div className="form-screen">
                <div className="container mb-3">
                    <div className="row d-flex mx-2 row-containers">
                        <div className="col-lg-5  col-md-11 form-container">
                            <h3 className='form-heading'>Banner Deatils</h3>
                            <form className='form-div' onSubmit={handleSubmit} ref={formRef} >
                                   <div className="display-order-container">
                                     <label>Do you have couple photo? </label>
                                       <div className='display-radios'>
                                          <label>
                                            <input type="radio"
                                             name="bannerType"
                                             value="photo"
                                             checked={values.bannerType==="photo"}
                                             onChange={handleChange}
                                              style={{ marginRight: "5px" }}
                                             />
                                               Yes
                                          </label>
                                          <label>
                                              <input type="radio" 
                                                name='bannerType'
                                                value="noPhoto"
                                                checked={values.bannerType==="noPhoto"}
                                                   onChange={handleChange}
                                                style={{ marginRight: "5px" }}
                                              />
                                              No
                                          </label>
                                        
                                       </div>
                                   </div>
                                
                                    <div className="display-order-container">
                                    <label>This invitation is from: </label>
                                    <div className='display-radios'>
                                        <label>
                                            <input
                                                type="radio"
                                                name="displayOrder"
                                                value="groomFirst"
                                                checked={values.displayOrder === "groomFirst"}
                                                onChange={handleChange}
                                                style={{ marginRight: "5px" }}
                                            />
                                            Groom’s Side
                                        </label>
                                        <label>
                                            <input
                                                type="radio"
                                                name="displayOrder"
                                                value="brideFirst"
                                                checked={values.displayOrder === "brideFirst"}
                                                onChange={handleChange}
                                                style={{ marginRight: "5px" }}
                                            />
                                            Bride’s Side
                                        </label>
                                    </div>
                                </div>
                                {values.displayOrder==="groomFirst"?<>
                                    { groomFeild()}
                               {brideFeild()}
                                </>:
                                <>
                                  {brideFeild()}
                                      { groomFeild()} 
                                </>
                                }
                             
        
                                <div className={errors.hashtag ? "form-input-div-error" : "form-input-div"}>
                                    <input type="search"
                                        name="hashtag"
                                        value={values.hashtag}
                                        onChange={handleChange}
                                        placeholder=' '
                                        className={errors.hashtag ? "form-input-field-error" : "form-input-field"}
                                    />
                                   
                                    <label>Wedding Hashtag <span className='label-hide'>(optional)</span>  </label>
                                </div>
                                <div className='error-wedding-div'>  {errors.hashtag && (<small className="error-msg-wedding">{errors.hashtag}</small>)}</div>
                                
                               
                               {values.bannerType==="photo" &&   <div className='file-input'>
                                    <label htmlFor="">Couple Photo</label>
                                    <div className='banner-buttons'>
                                        <button type="button" className='default-banner-button' onClick={handleDefaultBg} >Choose a Sample Photo</button>
                                        <span>or</span>
                                        <button type="button" className='default-banner-button' onClick={handleCropper} >Upload Your Photo</button>
                                    </div>
                                </div> }
                              

                                   <div className="align-div pt-3" >
                                    <label htmlFor="nameFontStyle">Name Font Style</label>
                                    <select
                                        id="nameFontStyle"
                                        name="nameFontStyle"
                                        value={values.nameFontStyle}
                                        onChange={handleChange}
                                        className="form-input-field"
                                    >
                                        {NamefontFamilies.map((family) => (
                                            <option key={family.value} value={family.value} style={{ fontFamily: family.value }}>
                                                {family.label}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                {values.bannerType==="photo" && <>
                                                                <div className='align-div'>
                                    <label htmlFor="fontAlignment">Font Alignment</label>
                                    <select
                                        id="fontAlignment"
                                        name="fontAlignment"
                                        value={values.fontAlignment}
                                        onChange={handleChange}
                                        className="form-input-field"
                                    >
                                        <option value="top" style={{ color: "black" }}>Top</option>
                                        <option value="bottom" style={{ color: "black" }}>Bottom</option>
                                    </select>
                                </div>

                                <div className="align-div">
                                    <label htmlFor="fontColor">Font Color</label>
                                    <div>
                                        {/* Color Box to Show Selected Color */}
                                        <div
                                            onClick={toggleColorPicker}
                                            className='color-picker'
                                            style={{
                                                backgroundColor: values.fontColor
                                            }}
                                        />

                                        {/* Display the color picker on click */}
                                        {displayColorPicker ? (
                                            <div style={{ position: 'absolute', zIndex: '2' }}>
                                                <div
                                                    style={{
                                                        position: 'fixed',
                                                        top: '0px',
                                                        right: '0px',
                                                        bottom: '0px',
                                                        left: '0px',
                                                    }}
                                                    onClick={handleClose}
                                                />
                                                <ChromePicker color={values.fontColor} onChange={handleColorChange} />
                                            </div>
                                        ) : null}
                                    </div>
                                </div>
                                </> }

                                <button type='submit' className='form-submit-button'>Save & Continue</button>
                            </form>
                        </div>


                        {loading ? "loading" : <>
                            <div className={
    values.bannerType === "photo"
      ? "col-lg-5 col-md-11 preview-container p-0"
      : `col-md-11 preview-container p-0 no-photo-preview-container ${values.theme?`preview-con-${values.theme}`:""}`
  }>
                         <BannerPreview  values={values} theme={values?.theme}/>
                            </div>
                        </>}
                    </div>
                </div>
            </div>
            {defalutBgConatiner && <BackgroundContainer handleDefaultBg={handleDefaultBg} rerenderBg={rerenderBg} values={values} />}
            {showCropper && <CropperCom handleCropper={handleCropper} setValues={setValues} values={values} imageType="bannerImage" />}
        </>
    )
}

export default BasicDetailsForm